import React from 'react';
import CustomSelect from '../../../components/forms/CustomSelect';
import DateField from '../../../components/forms/DateField';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import { FilterOptions } from '../../../hooks/useFilters';
import useUsers from '../../../hooks/api-calls/useUsers';
import useCompanies from '../../../hooks/api-calls/useCompanies';

interface UsersFiltersProps {
    updateFilters: (filters: any) => void
    filters: FilterOptions
}

const WorkHoursFilters: React.FC<UsersFiltersProps> = ({ filters, updateFilters }) => {

    // HOOKS

    const { userCan } = usePrivilege();
    const { getUsersList } = useUsers();
    const { getCompaniesList } = useCompanies();
    
    // RENDER

    return (
        <>
            <CustomSelect
                isSearchable
                isMulti
                id={'userId'}
                label="Usuario"
                options={getUsersList()}
                onChange={(e: any) => { updateFilters({ users: e.map((user: any) => user.value) }) }}
                value={
                    filters.filter_filters?.users
                        ? getUsersList().filter((user: any) => filters.filter_filters?.users.includes(user.value))
                        : []
                }
                display={userCan('list', 'user')}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Creación"
                placeholderText="Selecciona las fechas"
                selectedDateField={filters.filter_filters?.between_dates?.type || "createdAt"}
                dateTypesOptions={[
                    { label: "Fecha de creación", value: "createdAt" },
                    { label: "Fecha de modificación", value: "updatedAt" },
                    { label: "Registro horario", value: "workDate" },
                ]}
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                popperPlacement="bottom-start"
                popperClassName="!z-[9999] !h-64"
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;
                    if (between_dates && filters_between_dates !== between_dates) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1], type: date[2] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />

            {userCan('list', 'company') && (
                <CustomSelect
                    isSearchable
                    id="company"
                    label="Compañía"
                    options={getCompaniesList()}
                    value={getCompaniesList().find((item: any) => item.value === filters.filter_filters?.company) ?? { label: 'Todas', value: 'null' }}
                    onChange={(e: any) => {
                        if (e.value === 'null') {
                            updateFilters({ company: null });
                            return;
                        }
                        updateFilters({ company: e.value });
                    }}
                />  
            )}
        </>
    );
};

export default WorkHoursFilters;
